module.exports = __webpack_public_path__ + "static/media/points_indicator_bg.26c1c4c4.png";